module.exports = __webpack_public_path__ + "static/media/uniform-app-store.9bdef279.png";